import { Link } from 'react-router-dom';
import { GlassPanel } from '../ui/GlassPanel';

// Props: to, label, description, icon, action? { icon, label, onClick, active }
export function NavCard({ to, label, description, icon, action }) {
  return (
    <GlassPanel
      as={Link}
      to={to}
      aria-label={`Go to ${label}`}
      className="
        group flex flex-col justify-between
        p-4 lg:p-5 h-full
        hover:bg-white/[0.06] hover:border-[var(--color-accent)]/20
        focus-visible:ring-2 focus-visible:ring-[var(--color-accent)]/60
        transition-all duration-200 cursor-pointer no-underline
      "
    >
      <div className="flex items-start justify-between">
        <span
          aria-hidden="true"
          className="text-2xl text-[var(--color-accent)]/60 group-hover:text-[var(--color-accent)] transition-colors"
        >
          {icon}
        </span>
        <div className="flex items-center gap-1.5">
          {action && (
            <button
              onClick={e => { e.preventDefault(); e.stopPropagation(); action.onClick(); }}
              title={action.label}
              className={[
                'text-[9px] px-1.5 py-0.5 rounded border transition-colors cursor-pointer',
                action.active
                  ? 'border-[var(--color-accent)]/40 text-[var(--color-accent)] bg-[var(--color-accent)]/10'
                  : 'border-white/[0.08] text-[var(--color-muted)]/60 hover:text-[var(--color-text)] hover:border-white/20',
              ].join(' ')}
            >
              {action.icon}
            </button>
          )}
          <span
            aria-hidden="true"
            className="text-[var(--color-muted)]/40 group-hover:text-[var(--color-accent)]/60 transition-colors text-lg"
          >
            →
          </span>
        </div>
      </div>

      <div className="mt-3">
        <h3 className="text-sm font-semibold text-[var(--color-text)] group-hover:text-[var(--color-accent)] transition-colors">
          {label}
        </h3>
        {description && (
          <p className="text-xs text-[var(--color-muted)] mt-0.5 leading-relaxed hidden lg:block">
            {description}
          </p>
        )}
      </div>
    </GlassPanel>
  );
}
